export const WIN = 'win';
export const LOSE = 'lose';
export const DRAW = 'draw';
